import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _MoreFilters;

import React, { useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import RkoTypeSelect from 'components/RkoTypeSelect';
import MoreFilters from 'components/MoreFilters';
import FilterButton from 'components/FilterButton';
import { useSelectorProps } from 'hooks';
import { getFormattedSearchParams, getFormattedRouterUrlState } from 'selectors';
import { PRODUCT_TYPES } from 'constants/index';
import { AllFiltersWrapper, MainFilterWrapper } from './styles';

function ProductsFiltersForm() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleFilterButtonClick = useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  var selectorProps = useSelectorProps();
  var searchParams = useSelector(function (state) {
    return getFormattedSearchParams(state, selectorProps);
  });
  var routerUrlState = useSelector(function (state) {
    return getFormattedRouterUrlState(state, selectorProps);
  });
  var rkoType = useMemo(function () {
    var _searchParams$type, _searchParams$type$;

    return routerUrlState.page ? routerUrlState.page : (searchParams == null ? void 0 : (_searchParams$type = searchParams.type) == null ? void 0 : (_searchParams$type$ = _searchParams$type[0]) == null ? void 0 : _searchParams$type$.toLowerCase()) || PRODUCT_TYPES.all;
  }, [searchParams.type, routerUrlState.page]);
  return /*#__PURE__*/_jsx(AllFiltersWrapper, {}, void 0, /*#__PURE__*/_jsx(MainFilterWrapper, {
    noValidate: true
  }, void 0, /*#__PURE__*/_jsx(RkoTypeSelect, {
    defaultValueId: rkoType
  }), /*#__PURE__*/_jsx(FilterButton, {
    isOpen: isOpen,
    onButtonCLick: handleFilterButtonClick
  })), isOpen && (_MoreFilters || (_MoreFilters = /*#__PURE__*/_jsx(MoreFilters, {}))));
}

export default ProductsFiltersForm;